import React from "react";

export default function Footer() {
  return (
    <footer className="bg-[#00254D] text-white py-4 px-6 md:px-10 flex flex-col sm:flex-row justify-between items-center">
      {/* Left side */}
      <div className="text-sm sm:text-base font-light">
        © {new Date().getFullYear()} PSTVue
      </div>

      {/* Right side */}
      {/* <div className="flex space-x-4 mt-2 sm:mt-0">
        <a
          href="#"
          className="hover:text-[#a3b4ff] text-sm sm:text-base"
        >
          Privacy Policy
        </a>
        <a
          href="#"
          className="hover:text-[#a3b4ff] text-sm sm:text-base"
        >
          Terms of Service
        </a>
        <a
          href="#"
          className="hover:text-[#a3b4ff] text-sm sm:text-base"
        >
          Contact
        </a>
      </div> */}

      <div className="flex space-x-4 mt-2 sm:mt-0">
        support@mnrtechnologies.com
      </div>
    </footer>
  );
}
